// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import SideMenu from "@store/Library/Components/Toolkit/SideMenu";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface AccountSideMenuStyles {
    wrapper?: InjectableCss;
}

export const accountSideMenuStyles: AccountSideMenuStyles = {
    wrapper: {
        css: css`
            ${spacingStyles()}
            width: 100%;
        `,
    },
};

const styles = accountSideMenuStyles;

const AccountSideMenu: FC<WidgetProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <SideMenu pageType={constants.pageType.myAccount} showRootPage showSignOut />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AccountSideMenu,
    definition: {
        group: "My Account",
        icon: "bars",
        displayName: "Account Menu",
    },
};

export default widgetModule;
